import ApiService from './fetch.service';

class CategoriesService {
    getArticlesForCategory(category: string) {
        return ApiService.get(`/public/categories/${category}`);
    }

    getCategories() {
        return ApiService.get(`/public/categories`);
    }
}

export default new CategoriesService();



// WEBPACK FOOTER //
// ./src/api/categories.service.ts